export enum SupportedDeviceType {
  IOS_DEVICE = "IOS_DEVICE",
  IOS_EMULATOR = "IOS_EMULATOR",
  NULL = "NULL"
}
